import { DEFAULT_CACHE_STALE_TIME_MS } from "@frontend-shared/constants/app";
import { useQuery } from "@tanstack/react-query";

import { authApi } from "@/api/services";

/**
 * Hook to check if registration is enabled
 * @returns Query object with registrationEnabled flag
 */
export const useRegistrationStatus = () => {
  return useQuery({
    queryKey: ["status"],
    queryFn: () => authApi.getRegistrationStatus(),
    staleTime: DEFAULT_CACHE_STALE_TIME_MS,
    retry: 1,
  });
};
